export { default } from './offer-tooltip';
